<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.el-pagination {
  white-space: nowrap;
  padding: 20px 0 0 0;
  color: #303133;
  font-weight: 700;
}

.navright {
  display: none;
}



@media screen and (max-width: 700px) {
  .headerM {
    padding: 15px !important;
    margin: 0 auto;
    position: relative;
    width: 100%;
    font-size: 18px !important;
  }

  .headerM .logo {
    font-size: 14px !important;
  }

  .navright {
    display: none;
  }

  .el-main {
    width: 100% !important;
    background: #fff !important;
    margin: auto;
    padding: 0px 25px 25px 25px !important;
  }

  #contentstyle {
    display: none;
  }

  #applicationsyle {
    width: 100% !important;
  }

  .leftAPP_1 dl dt img {
    width: 30px !important;
    height: 30px !important;
  }

  .leftAPP_1 dl dt {
    width: 30px !important;
    height: 30px !important;
    margin: 0 auto;
    border-radius: 3px !important;
    position: relative;
    background: #fff;
  }

  .leftAPP_1 dl dd {
    background: #fff;
  }
  .leftAPP_1 dl {
        float: left;
        width: 60px;
        text-align: center;
        margin: 24px 0 0 55px;
    }
  .appsty2 .leftAPP_1 dl {
    float: left;
    text-align: center;
    width: 85px !important;
    margin: 15px 0px 0px 0px !important;
  }

  .realtimeTj dl dd span {
    display: block;
    font-size: 12px !important;
    padding: 0 0 10px 0 !important;
    color: #48addb;
  }

  .realtimeTj dl {
    margin: 5px !important;
  }

  .realtimeTj dl dt {
    height: 18px !important;
    font-size: 12px !important;
  }

  .banner1[data-v-1616b820] {
    height: 120px !important;
  }

  .el-carousel__container {
    height: 120px !important;
  }

  .leftAPP {
    padding: 0px 0px 20px 0px !important;
  }

  .ge_greenBox[data-v-5997211e] {
    width: 80px !important;
    height: 80px !important;
    margin-right: 20px !important;
  }

  a {
    font-size: 12px;
  }

  .appsty2 h3 span {
    color: #333;
    float: left;
    padding: 0 12px !important;
    font-size: 22px !important;
    height: 38px;
    line-height: 38px;
    font-weight: 400;
    font-size: 18px !important;
  }

  .realtimeTj h3 span {
    color: #333;
    float: left;
    padding: 0 12px !important;
    font-size: 13px !important;
    height: 38px;
    line-height: 38px;
    font-weight: 400;
  }

  .tjimage {
    width: 20px;
    height: 20px !important;
  }

  .realtimeTj dl dd .yyImg {
    height: 23px !important;
  }

  .leftAPP_1 bgBlueList {
    margin: 0 auto;
  }

  
}
</style>



// WEBPACK FOOTER //
// src/App.vue